import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import SVGIcon from "web/react/components/svg-icon/svg-icon";
import classnames from "classnames";
import { useClickTracker } from "web/react/hooks/use-click-tracker/use-click-tracker";
import LazyLoadImage from "web/react/components/lazy-load-image/lazy-load-image";
import Rail from "web/react/components/rail/rail";
import styles from "./featured-banners.css";
export function FeaturedBannerItem(_ref) {
  var title = _ref.title,
      text = _ref.text,
      ctaText = _ref.cta_text,
      url = _ref.url,
      imgUrl = _ref.image_url;
  var eventCategory = "featured banner homepage";
  var eventAction = "clicked";
  var textOnClick = useClickTracker(eventCategory, eventAction, "text: ".concat(text));
  var imageOnClick = useClickTracker(eventCategory, eventAction, "image: ".concat(text));
  return React.createElement("div", {
    className: styles.featuredItem
  }, React.createElement("a", {
    href: url,
    onClick: imageOnClick,
    role: "presentation"
  }, React.createElement(LazyLoadImage, {
    className: styles.featuredImage,
    src: imgUrl,
    role: "presentation"
  })), React.createElement("a", {
    href: url,
    onClick: textOnClick
  }, React.createElement("h3", {
    className: styles.title
  }, title), React.createElement("p", {
    className: styles.teaser
  }, text), React.createElement("span", {
    className: styles.ctaLink
  }, ctaText, " ", React.createElement(SVGIcon, {
    className: styles.chevron,
    name: "chevron"
  }))));
}

function FeaturedBanners(_ref2) {
  var bannerRows = _ref2.banner_rows;
  var leftButtonStyle = classnames(styles.scrollButton, styles.left);
  var rightButtonStyle = classnames(styles.scrollButton, styles.right);
  return React.createElement("div", {
    className: styles.featuredBannersWrap
  }, React.createElement(Rail, {
    title: "",
    analyticsLabel: "featured-banners",
    leftButtonStyle: leftButtonStyle,
    rightButtonStyle: rightButtonStyle,
    buttonIcon: "square-chevron",
    className: styles.featuredBanners
  }, bannerRows.map(function (row) {
    return row.map(function (item) {
      return React.createElement(FeaturedBannerItem, _extends({
        key: item.url
      }, item));
    });
  })));
}

export default FeaturedBanners;